/**
 * Nepali locale for messaging-ui.
 * Export is the "messaging" subtree for host i18n merge.
 */
import type { MessagingLocale } from './en'

export const messagingNe = {
  list: {
    loading: `सन्देश समूहहरू लोड हुँदैछ...`,
    error: `त्रुटि`,
    empty: `कुनै सन्देश समूह भेटिएन`,
    emptyDescription: `यो पीबीएक्समा हाल कुनै सन्देश समूह कन्फिगर गरिएको छैन।`,
    deleteConfirmTitle: `सन्देश समूह मेटाउनुहोस्`,
    deleteConfirm: `के तपाईं "{{name}}" मेटाउन निश्चित हुनुहुन्छ?`,
    smsEnabled: `सक्रिय`,
    smsDisabled: `निष्क्रिय`,
    delete: `मेटाउनुहोस्`,
    columnGroupName: `समूहको नाम`,
    columnPrimarySms: `प्राथमिक एसएमएस`,
    columnMembers: `सदस्यहरू`,
    columnSmsStatus: `एसएमएस स्थिति`,
    columnCreated: `सिर्जना गरिएको`,
    columnUpdated: `अद्यावधिक गरिएको`,
    columnActions: `कार्यहरू`,
    toast: {
      createdTitle: `सन्देश समूह सिर्जना भयो`,
      createdDescription: `"{{name}}" सफलतापूर्वक सिर्जना गरिएको छ।`,
      createFailedTitle: `सिर्जना असफल`,
      createFailedDescription: `सन्देश समूह सिर्जना गर्न असफल भयो`,
      deletedTitle: `सन्देश समूह मेटाइयो`,
      deletedDescription: `"{{name}}" मेटाइएको छ।`,
      deleteFailedTitle: `मेटाउन असफल`,
      deleteFailedDescription: `सन्देश समूह मेटाउन असफल भयो`,
    },
    title: `सन्देश`,
    createButton: `+ समूह सिर्जना गर्नुहोस्`,
    searchPlaceholder: `नाम वा फोन नम्बरले खोज्नुहोस्...`,
    noResults: `कुनै परिणाम छैन`,
    noResultsDescription: `"{{search}}" सँग मेल खाने कुनै सन्देश समूह छैन।`,
    noMembersWarning: `यो समूहमा कुनै सदस्य छैनन्। ग्राहकका सन्देशहरू नपढिएका रहन सक्छन्।`,
  },
  detail: {
    validationErrorTitle: `प्रमाणीकरण त्रुटि`,
    validationErrorDescription: `समूहको नाम आवश्यक छ`,
    toast: {
      updatedTitle: `सन्देश समूह अपडेट भयो`,
      updateFailedTitle: `अपडेट असफल`,
      updateFailedDescription: `सन्देश समूह अपडेट गर्न असफल भयो`,
      smsAddedTitle: `एसएमएस नम्बर थपियो`,
      smsAddFailedTitle: `एसएमएस नम्बर थप्न असफल भयो`,
      smsRemovedTitle: `एसएमएस नम्बर हटाइयो`,
      smsRemoveFailedTitle: `एसएमएस नम्बर हटाउन असफल भयो`,
      memberAddedTitle: `सदस्य थपियो`,
      memberAddFailedTitle: `सदस्य थप्न असफल भयो`,
      memberAddFailedDescription: `समूहमा सदस्य थप्न असफल भयो`,
      memberRemovedTitle: `सदस्य हटाइयो`,
      memberRemoveFailedTitle: `सदस्य हटाउन असफल भयो`,
    },
    loading: `सन्देश समूह लोड हुँदैछ...`,
    error: `त्रुटि`,
    notFound: `सन्देश समूह भेटिएन।`,
    title: `सन्देश समूह सम्पादन गर्नुहोस्`,
    viewTitle: `सन्देश समूह`,
    groupNameLabel: `समूहको नाम`,
    groupNamePlaceholder: `समूहको नाम प्रविष्ट गर्नुहोस्`,
    primarySmsLabel: `प्राथमिक एसएमएस नम्बर`,
    primarySmsPlaceholder: `प्राथमिक एसएमएस नम्बर छान्नुहोस्`,
    campaignIdWarning: `छानिएको नम्बरमा अभियान ID छैन र एसएमएस पठाउन सक्षम नहुन सक्छ, जबसम्म यो टोल-फ्री सेवा वा क्यानेडियन नम्बर होइन।`,
    associatedSmsLabel: `माध्यमिक एसएमएस नम्बरहरू`,
    noCampaignId: `(अभियान ID छैन)`,
    removeSmsAria: `एसएमएस नम्बर हटाउनुहोस्`,
    addSmsNumberAria: `एसएमएस नम्बर थप्नुहोस्`,
    unsavedChanges: `सुरक्षित नगरिएका परिवर्तनहरू`,
    campaignSummaryTitle: `{{count}} नम्बर(हरू)मा अभियान ID छैन`,
    campaignSummaryDescription: `यी नम्बरहरूले एसएमएस पठाउन सक्षम नहुन सक्छन् जबसम्म तिनीहरू टोल-फ्री वा क्यानेडियन नम्बरहरू होइनन्।`,
    backToList: `← सूचीमा फर्कनुहोस्`,
    updating: `अपडेट हुँदैछ...`,
    updateButton: `सन्देश समूह अपडेट गर्नुहोस्`,
    noMembersWarning: `यो समूहमा कुनै सदस्य छैनन्। ग्राहकका सन्देशहरू नपढिएका रहन सक्छन्।`,
  },
  createModal: {
    validationErrorTitle: `प्रमाणीकरण त्रुटि`,
    validationErrorDescription: `कृपया सन्देश समूहको लागि नाम प्रविष्ट गर्नुहोस्`,
    title: `सन्देश समूह सिर्जना गर्नुहोस्`,
    nameLabel: `समूहको नाम`,
    namePlaceholder: `समूहको नाम प्रविष्ट गर्नुहोस्`,
    primarySmsLabel: `प्राथमिक एसएमएस नम्बर`,
    primarySmsPlaceholder: `नम्बर छान्नुहोस्`,
    primarySmsRequired: `कृपया प्राथमिक एसएमएस नम्बर छान्नुहोस्`,
    cancel: `रद्द गर्नुहोस्`,
    creating: `सिर्जना हुँदैछ...`,
    createButton: `समूह सिर्जना गर्नुहोस्`,
  },
  members: {
    groupMembersTitle: `समूह सदस्यहरू`,
    emptyGroup: `यो समूहमा अहिलेसम्म कुनै सदस्य छैनन्।`,
    columnName: `नाम`,
    columnExtension: `एक्सटेन्सन`,
    columnAdded: `थपिएको`,
    availableMembersTitle: `उपलब्ध सदस्यहरू`,
    emptyAvailable: `थप्नका लागि कुनै उपलब्ध सदस्य छैनन्।`,
    removeMemberAria: `सदस्य हटाउनुहोस्`,
    addMemberAria: `सदस्य थप्नुहोस्`,
    searchPlaceholder: `नाम वा एक्सटेन्सनले खोज्नुहोस्...`,
    noSearchResults: `तपाईंको खोजसँग मिल्ने कुनै सदस्य छैनन्।`,
  },
  smsModal: {
    validationErrorTitle: `प्रमाणीकरण त्रुटि`,
    validationErrorDescription: `कृपया एसएमएस नम्बर छान्नुहोस्`,
    title: `सम्बन्धित एसएमएस नम्बरहरू`,
    label: `सम्बन्धित एसएमएस नम्बरहरू`,
    loading: `लोड हुँदैछ...`,
    selectPlaceholder: `नम्बर छान्नुहोस्`,
    submitting: `पेश गरिँदैछ...`,
    submit: `पेश गर्नुहोस्`,
    close: `बन्द गर्नुहोस्`,
  },
  pagination: {
    resultsPerPage: `पृष्ठमा नतिजा:`,
    previousPage: `अघिल्लो पृष्ठ`,
    nextPage: `अर्को पृष्ठ`,
    jumpToPage: `पृष्ठ {{page}} मा जानुहोस्`,
    all: `सबै`,
  },
} satisfies MessagingLocale
